import React from 'react';
import { Severity } from '../../types/types';
import './StatusTag.scss';

type StatusTagSize = 'small' | 'medium' | 'large';

interface StatusTagProps {
  label: string;
  severity: Severity;
  size?: StatusTagSize;
  className?: string;
}

/**
 * StatusTag component for displaying status indicators with appropriate styling based on severity
 */
export const StatusTag: React.FC<StatusTagProps> = ({
  label,
  severity = 'neutral',
  size = 'medium',
  className = '',
}) => {
  return <div className={`status-tag status-tag--${severity} status-tag--${size} ${className}`}>{label}</div>;
};

export default StatusTag;
